var map = {
	"./addnew_4_empty.svg": "./src/assets/iconSvg/svg/addnew_4_empty.svg",
	"./backspace.svg": "./src/assets/iconSvg/svg/backspace.svg",
	"./camera.svg": "./src/assets/iconSvg/svg/camera.svg",
	"./compare-eq.svg": "./src/assets/iconSvg/svg/compare-eq.svg",
	"./compare-in.svg": "./src/assets/iconSvg/svg/compare-in.svg",
	"./compare-is.svg": "./src/assets/iconSvg/svg/compare-is.svg",
	"./compare-lge.svg": "./src/assets/iconSvg/svg/compare-lge.svg",
	"./compare-lgt.svg": "./src/assets/iconSvg/svg/compare-lgt.svg",
	"./compare-like.svg": "./src/assets/iconSvg/svg/compare-like.svg",
	"./compare-lt.svg": "./src/assets/iconSvg/svg/compare-lt.svg",
	"./compare-lte.svg": "./src/assets/iconSvg/svg/compare-lte.svg",
	"./compare-ng.svg": "./src/assets/iconSvg/svg/compare-ng.svg",
	"./compare-nin.svg": "./src/assets/iconSvg/svg/compare-nin.svg",
	"./compare-nis.svg": "./src/assets/iconSvg/svg/compare-nis.svg",
	"./compare-not-like.svg": "./src/assets/iconSvg/svg/compare-not-like.svg",
	"./danger-delete.svg": "./src/assets/iconSvg/svg/danger-delete.svg",
	"./danger-detail.svg": "./src/assets/iconSvg/svg/danger-detail.svg",
	"./empty-data.svg": "./src/assets/iconSvg/svg/empty-data.svg",
	"./expression-delete.svg": "./src/assets/iconSvg/svg/expression-delete.svg",
	"./expression-redo.svg": "./src/assets/iconSvg/svg/expression-redo.svg",
	"./expression-undo.svg": "./src/assets/iconSvg/svg/expression-undo.svg",
	"./graph-node-addfield.svg": "./src/assets/iconSvg/svg/graph-node-addfield.svg",
	"./graph-node-casewhen-bg.svg": "./src/assets/iconSvg/svg/graph-node-casewhen-bg.svg",
	"./graph-node-casewhen.svg": "./src/assets/iconSvg/svg/graph-node-casewhen.svg",
	"./graph-node-execute-2.svg": "./src/assets/iconSvg/svg/graph-node-execute-2.svg",
	"./graph-node-execute-circle.svg": "./src/assets/iconSvg/svg/graph-node-execute-circle.svg",
	"./graph-node-execute-error.svg": "./src/assets/iconSvg/svg/graph-node-execute-error.svg",
	"./graph-node-execute-running.svg": "./src/assets/iconSvg/svg/graph-node-execute-running.svg",
	"./graph-node-execute-stop.svg": "./src/assets/iconSvg/svg/graph-node-execute-stop.svg",
	"./graph-node-execute.svg": "./src/assets/iconSvg/svg/graph-node-execute.svg",
	"./graph-node-filter.svg": "./src/assets/iconSvg/svg/graph-node-filter.svg",
	"./graph-node-group.svg": "./src/assets/iconSvg/svg/graph-node-group.svg",
	"./graph-node-input.svg": "./src/assets/iconSvg/svg/graph-node-input.svg",
	"./graph-node-join.svg": "./src/assets/iconSvg/svg/graph-node-join.svg",
	"./graph-node-model-edit.svg": "./src/assets/iconSvg/svg/graph-node-model-edit.svg",
	"./graph-node-model-error.svg": "./src/assets/iconSvg/svg/graph-node-model-error.svg",
	"./graph-node-model-ok.svg": "./src/assets/iconSvg/svg/graph-node-model-ok.svg",
	"./graph-node-model-result-off.svg": "./src/assets/iconSvg/svg/graph-node-model-result-off.svg",
	"./graph-node-model-result-ok.svg": "./src/assets/iconSvg/svg/graph-node-model-result-ok.svg",
	"./graph-node-output.svg": "./src/assets/iconSvg/svg/graph-node-output.svg",
	"./graph-node-result.svg": "./src/assets/iconSvg/svg/graph-node-result.svg",
	"./graph-node-selectfield.svg": "./src/assets/iconSvg/svg/graph-node-selectfield.svg",
	"./graph-node-union.svg": "./src/assets/iconSvg/svg/graph-node-union.svg",
	"./logo-targus.svg": "./src/assets/iconSvg/svg/logo-targus.svg",
	"./message.svg": "./src/assets/iconSvg/svg/message.svg",
	"./no_permission.svg": "./src/assets/iconSvg/svg/no_permission.svg",
	"./robot.svg": "./src/assets/iconSvg/svg/robot.svg",
	"./rule-add.svg": "./src/assets/iconSvg/svg/rule-add.svg",
	"./rule-delete.svg": "./src/assets/iconSvg/svg/rule-delete.svg",
	"./rule-indent-dec.svg": "./src/assets/iconSvg/svg/rule-indent-dec.svg",
	"./rule-indent-inc.svg": "./src/assets/iconSvg/svg/rule-indent-inc.svg",
	"./u10.svg": "./src/assets/iconSvg/svg/u10.svg",
	"./u11.svg": "./src/assets/iconSvg/svg/u11.svg",
	"./u12.svg": "./src/assets/iconSvg/svg/u12.svg",
	"./u20.svg": "./src/assets/iconSvg/svg/u20.svg",
	"./u24.svg": "./src/assets/iconSvg/svg/u24.svg",
	"./u33.svg": "./src/assets/iconSvg/svg/u33.svg",
	"./u9.svg": "./src/assets/iconSvg/svg/u9.svg",
	"./userhome-aigjx.svg": "./src/assets/iconSvg/svg/userhome-aigjx.svg",
	"./userhome-fxhg.svg": "./src/assets/iconSvg/svg/userhome-fxhg.svg",
	"./userhome-fxjsc.svg": "./src/assets/iconSvg/svg/userhome-fxjsc.svg",
	"./userhome-fxlj.svg": "./src/assets/iconSvg/svg/userhome-fxlj.svg",
	"./userhome-fxyy.svg": "./src/assets/iconSvg/svg/userhome-fxyy.svg",
	"./userhome-hggl.svg": "./src/assets/iconSvg/svg/userhome-hggl.svg",
	"./userhome-jjjc.svg": "./src/assets/iconSvg/svg/userhome-jjjc.svg",
	"./userhome-nbkz.svg": "./src/assets/iconSvg/svg/userhome-nbkz.svg",
	"./userhome-nbsj.svg": "./src/assets/iconSvg/svg/userhome-nbsj.svg",
	"./userhome-rwgl.svg": "./src/assets/iconSvg/svg/userhome-rwgl.svg",
	"./userhome-sy.svg": "./src/assets/iconSvg/svg/userhome-sy.svg",
	"./userhome-xtgl.svg": "./src/assets/iconSvg/svg/userhome-xtgl.svg",
	"./userhome-zhgf.svg": "./src/assets/iconSvg/svg/userhome-zhgf.svg",
	"./wbManage.svg": "./src/assets/iconSvg/svg/wbManage.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/iconSvg/svg sync \\.svg$";